export default __webpack_public_path__ + "static/media/unauthorized.55224c9b.png";